export const useLoading = (isLoading: boolean, componentLoader: JSX.Element) => {
	if (isLoading) {
		return componentLoader;
	}
	return null
}
